<script>
    import { createEventDispatcher } from 'svelte';
  
    export let userName = 'Juan Pérez';  // prop para el nombre de usuario
  
    export let isCollapseOpen = false;
    export let searchQuery = '';
  
    const dispatch = createEventDispatcher();
  
    // Funciones internas que emiten eventos al padre
    function toggleCollapse() {
      dispatch('toggleCollapse');
    }
  
    function toggleProfile() {
      isProfileOpen = !isProfileOpen;
    }
  
    function closeProfile() {
      isProfileOpen = false;
    }
  
    let isProfileOpen = false;
  
    function onSearch() {
      dispatch('search', { query: searchQuery });
    }
  
    function changePassword() {
      dispatch('changePassword');
      closeProfile();
    }
  
    function logout() {
      dispatch('logout');
      closeProfile();
    }
  
    // Acción para cerrar perfil click afuera
    function clickOutside(node) {
      const onClick = event => {
        if (!node.contains(event.target)) {
          closeProfile();
        }
      };
      document.addEventListener('click', onClick, true);
      return {
        destroy() {
          document.removeEventListener('click', onClick, true);
        }
      };
    }
  </script>
  
  <style>
    .logo-img {
      max-height: 30px;
      object-fit: contain;
    }
    .profile-icon {
      color: white;
      cursor: pointer;

    }
    .profile-icon i {
      font-size: 18px;
    }
    .search-input {
      width: 150px;
    }
    .user-name {
      color: white;
      margin-left: 0.5rem;
      font-weight: 500;
      white-space: nowrap;
    }
    .dropdown-menu-custom {
      position: absolute;
      top: 40px;
      right: 0;
      background: white;
      color: black;
      border-radius: 0.25rem;
      min-width: 180px;
      box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 0.15);
      z-index: 1000;
    }
  
    .dropdown-menu-custom button {
      background: none;
      border: none;
      width: 100%;
      padding: 0.5rem 1rem;
      text-align: left;
      cursor: pointer;
    }
    .dropdown-menu-custom button:hover {
      background-color: #f8f9fa;
    }
  </style>
  
  <nav class="navbar navbar-dark  p-2" style="background: linear-gradient(90deg, #000000 0%, #ff007b 100%) !important;">
    <div class="container-fluid d-flex flex-wrap align-items-center">
      <!-- Logo más pequeño -->
      <div class="navbar-brand d-flex align-items-center me-3">
        <img
          class="logo-img"
          src="https://assets-usoft.universalsoft.net/bo_fontend/logo_small.png"
          alt="Logo"
        />
      </div>
      <!-- Toggle collapse botón visible sólo en pantallas pequeñas -->
      <button
        class="navbar-toggler d-md-none me-3"
        type="button"
        aria-expanded={isCollapseOpen}
        aria-label="Toggle navigation"
        on:click={toggleCollapse}
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <!-- Perfil con nombre y dropdown -->
      <div class="position-relative d-flex align-items-center ms-auto" use:clickOutside>
        <button
          class="btn profile-icon"
          type="button"
          aria-haspopup="true"
          aria-expanded={isProfileOpen}
          on:click={toggleProfile}
        >
          <i class="fa-solid fa-user"></i>
        </button>
        
        <span class="user-name">  Hola, {userName} 👋</span>
        {#if isProfileOpen}
        <div class="dropdown-menu-custom" role="menu" aria-label="Opciones de perfil">
          <button role="menuitem" on:click={logout}>
            <i class="fa-solid fa-power-off" style="margin-right: 8px;"></i> Salir
          </button>
        </div>
        {/if}
      </div>
    </div>
  </nav>
  